<template>
  <div>
    <ul>
      <li
        v-for="g of genres"
        :key="g"
        :class="[{ 'is-active': isActive(g) }, genreClass(g)]"
        @click="toggleGenre(g)"
      >
        <span class="icon"></span>
        <span class="name">{{ genreLabelShort(g) }}</span>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { mapState, mapActions } from 'vuex';
import genreHelper from '@/lib/GenreHelper.js';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Genre',
  computed: mapState(['genreFlags']),
  data() {
    return {
      genres: [
        'スーパー',
        'ドラッグストア',
        '百貨店・モール',
        'ディスカウントショップ',
        'ホームセンター'
      ]
    };
  },
  methods: {
    ...mapActions(['toggleGenre']),
    isActive(genre:string){
      return this.genreFlags[genre];
    },
    genreClass: genreHelper.genreClass,
    genreLabelShort: genreHelper.genreLabelShort
  }
});
</script>

<style scoped lang="scss">
div {
  width: 100%;
  max-width: 590px;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    display: none;
  }
}

ul {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;

  &:before,
  &:after {
    content: '';
    flex: 0 0 20px;
  }

  li {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    padding: 0 11px;
    height: 32px;
    user-select: none;
    border-radius: 100px;
    background-color: #bbbbbb;
    box-shadow: 2px 2px 4px #00000029;

    & + li {
      margin-left: 4px;
    }

    &.is-active {
      &.is-supermarket {
        background-color: #9d7ae0;
      }
      &.is-discountshop {
        background-color: #f27777;
      }
      &.is-homecenter {
        background-color: #af782e;
      }
      &.is-drugstore {
        background-color: #139351;
      }
      &.is-departmall {
        background-color: #4a5eb4;
      }
    }

    .icon {
      margin-right: 3px;
      background-size: 100% 100%;
    }

    &.is-supermarket {
      .icon {
        margin-left: -1px;
        width: 13px;
        height: 15px;
        background-image: url('@/assets/images/pic-market.svg');
      }
    }
    &.is-discountshop {
      .icon {
        margin-left: -3px;
        margin-right: 2px;
        width: 17px;
        height: 17px;
        background-image: url('@/assets/images/pic-discount.svg');
      }
    }
    &.is-homecenter {
      .icon {
        margin-right: 4px;
        width: 11px;
        height: 16px;
        background-image: url('@/assets/images/pic-homecenter.svg');
      }
    }
    &.is-drugstore {
      .icon {
        margin-left: 1px;
        width: 8px;
        height: 16px;
        background-image: url('@/assets/images/pic-drag.svg');
      }
    }
    &.is-departmall {
      .icon {
        margin-left: -2px;
        margin-right: 4px;
        width: 14px;
        height: 12px;
        background-image: url('@/assets/images/pic-mall.svg');
      }
    }

    .name {
      line-height: 32px;
      font-size: 12px;
      font-weight: bold;
      color: #fff;
    }
  }
}

@media screen and (max-width: 767px) {
  ul {
    &:before,
    &:after {
      flex: 0 0 10px;
    }
  }
}
</style>
